import { cloneDeep } from 'lodash';
import React from 'react';
import WidgetPaper from '@components/widgets/display-widget/WidgetPaper';
import WidgetSection from '@components/widgets/display-widget/WidgetSection';
import { IProposalPageFormState } from '../../page/generic/form';
import TextInputFormField from '@components/form-fields/TextInputFormField';
import SelectFormField from '@components/form-fields/SelectFormField';

interface IProposalDescriptionOfRiskWidgetProps {
  pageState: IProposalPageFormState;
  onPageStateUpdate: (pageState: IProposalPageFormState) => void;
  disabledForm?: boolean;
  lovs: Record<string, Record<string, string>>;
  status: string;
  lineExternalCode: string;
}

const ProposalDescriptionOfRiskWidget: React.FC<
  IProposalDescriptionOfRiskWidgetProps
> = ({
  pageState,
  onPageStateUpdate,
  disabledForm,
  lovs,
  lineExternalCode,
}) => {
  const values = pageState.values.descriptionOfRiskDetails;
  const errors = pageState.errors.descriptionOfRiskDetails;
  const touched = pageState.touched.descriptionOfRiskDetails;

  const onFieldBlur = (fieldName: string) => {
    const newPageState = cloneDeep(pageState);
    newPageState.touched.descriptionOfRiskDetails[fieldName] = true;
    onPageStateUpdate(newPageState);
  };

  const onFieldUpdate = (
    fieldName: keyof typeof values,
    value: (typeof values)[keyof typeof values],
    touched = false
  ) => {
    const newPageState = cloneDeep(pageState);
    newPageState.values.descriptionOfRiskDetails[fieldName] = value;

    if (touched) {
      newPageState.touched.descriptionOfRiskDetails[fieldName] = true;
    }

    onPageStateUpdate(newPageState);
  };

  return (
    <WidgetPaper>
      <WidgetSection title="Description of Risk" isFieldsGrid fieldsPerRow={2}>
        <TextInputFormField
          key="descriptionOfRisk"
          name="descriptionOfRisk"
          title="Description of Risk"
          placeholder="Description of Risk"
          value={values.descriptionOfRisk}
          error={touched.descriptionOfRisk ? errors.descriptionOfRisk : ''}
          onBlur={() => onFieldBlur('descriptionOfRisk')}
          onChange={(v) => onFieldUpdate('descriptionOfRisk', v.target.value)}
          disabled={disabledForm}
          material
        />

        {[
          '11',
          '15',
          '16',
          '25',
          '27',
          '29',
          '30',
          '31',
          '37',
          '38',
          '39',
          '42',
          '46',
        ].includes(lineExternalCode) && (
          <SelectFormField
            key="geoLocation"
            name="geoLocation"
            title="Geographical Location*"
            placeholder="Geographical Location"
            value={values.geoLocation}
            error={touched.geoLocation ? errors.geoLocation : ''}
            onChange={(v) => onFieldUpdate('geoLocation', v, true)}
            disabled={disabledForm}
            selectOptions={lovs.geoLocations}
            material
          />
        )}
      </WidgetSection>
    </WidgetPaper>
  );
};

export default ProposalDescriptionOfRiskWidget;
